// Shared "open Instacart in a new tab" flow for grocery-bulk#shopInstacart and
// recipe-instacart#shop. Opens a blank tab synchronously (so the popup isn't
// blocked), lets the caller resolve the real URL asynchronously, then points
// the tab at it — falling back to the link's own href on any failure.
//
// Guards re-entrancy via a dataset flag: on some mobile contexts nothing
// visibly opens until the async work resolves, which reads as "my tap didn't
// register" and invites a second tap — each one independently opening
// Instacart. A second call while one is in flight is a no-op, and the
// dimmed/aria-busy state gives the tap visible feedback immediately.
export async function openInstacartLink(link, resolveUrl) {
  if (link.dataset.busy === "true") return

  link.dataset.busy = "true"
  link.setAttribute("aria-busy", "true")
  link.classList.add("pointer-events-none", "opacity-60")

  const fallback = link.href
  const tab = window.open("", "_blank")
  const go = (url) => { if (tab) tab.location = url; else window.location.href = url }

  try {
    const url = await resolveUrl()
    go(url || fallback)
  } catch {
    go(fallback)
  } finally {
    link.classList.remove("pointer-events-none", "opacity-60")
    link.removeAttribute("aria-busy")
    delete link.dataset.busy
  }
}

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ""
}
